export default "__VITE_ASSET__DfY5a8Ec__"